import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import ContactMap from './components/ContactMap';

export default function ContactPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <ContactHero />

        {/* Main Content: Form + Info */}
        <section className="py-16 md:py-24 bg-[#fafaf8]">
          <div className="max-w-[1440px] mx-auto px-6 md:px-10">

            {/* Top Trust Bar */}
            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 py-8 mb-12 border-y border-[#e2ddd8]">
              {[
                { icon: 'ri-customer-service-2-line', text: '免費初步諮詢' },
                { icon: 'ri-time-line', text: '24小時內回覆' },
                { icon: 'ri-shield-check-line', text: '透明報價不含糊' },
                { icon: 'ri-map-2-line', text: '全台服務' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2.5 text-[#5a5a5a]">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${item.icon} text-[#b8956a] text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium whitespace-nowrap">{item.text}</span>
                </div>
              ))}
            </div>

            {/* Form + Sidebar */}
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
              {/* Form - wider */}
              <div className="w-full lg:w-7/12">
                <ContactForm />
              </div>
              {/* Info Sidebar */}
              <div className="w-full lg:w-5/12">
                <ContactInfo />
              </div>
            </div>
          </div>
        </section>

        <ContactMap />
      </main>
      <Footer />
    </div>
  );
}
